export default __webpack_public_path__ + "static/media/rose-image.03738238.png";